import React from 'react';
import PropTypes from 'prop-types';
import './styles/AlgorithmSelector.css';

const algorithms = [
  {
    id: 'dda',
    name: 'DDA Line Drawing',
    description: 'Digital Differential Analyzer - Simple incremental algorithm',
    icon: '─',
    ariaLabel: 'DDA Line Drawing algorithm'
  },
  {
    id: 'bresenham',
    name: 'Bresenham Line Drawing',
    description: 'Efficient integer-only line rasterization',
    icon: '╱',
    ariaLabel: 'Bresenham Line Drawing algorithm'
  },
  {
    id: 'midpoint-circle',
    name: 'Midpoint Circle Drawing',
    description: 'Efficient circle rasterization using midpoint concept',
    icon: '●',
    ariaLabel: 'Midpoint Circle Drawing algorithm'
  }
];

export default function AlgorithmSelector({ onSelectAlgorithm }) {
  return (
    <section className="algorithm-selector">
      <div className="selector-container">
        <h2>Select an Algorithm</h2>
        <div className="algorithm-grid">
          {algorithms.map((algo) => (
            <button
              key={algo.id}
              className="algorithm-card"
              onClick={() => onSelectAlgorithm(algo.id)}
              aria-label={algo.ariaLabel}
            >
              <div className="card-icon">{algo.icon}</div>
              <h3>{algo.name}</h3>
              <p>{algo.description}</p>
              <span className="select-btn">Explore →</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

AlgorithmSelector.propTypes = {
  onSelectAlgorithm: PropTypes.func.isRequired
};
